import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { FieldArray, useFormikContext } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import ReactDatePicker from 'react-datepicker';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
export const ProfessionalMembershipForm = ({ handleChange, values, handleBlur, errors, touched }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className="signite-form">
      <FieldArray name="professionalMemberships">
        {({ remove, push }) => (
          <>
            {values.professionalMemberships &&
              values.professionalMemberships.length > 0 &&
              values.professionalMemberships.map((professionalMembership, index) => (
                <div key={index}>
                  <Row className="mb-3" key={`r-${index}`}>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Name*</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`professionalMemberships.${index}.name`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={_.get(values, `professionalMemberships.${index}.name`)}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `professionalMemberships.${index}.name`
                        )}`}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `professionalMemberships.${index}.name`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Member Since</BSForm.Label>
                      <ReactDatePicker
                        name={`professionalMemberships.${index}.year`}
                        maxDate={new Date()}
                        onChange={(val) => {
                          setFieldValue(`professionalMemberships.${index}.year`, val.getFullYear(), true);
                        }}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `professionalMemberships.${index}.year`
                        )}`}
                        selected={
                          _.get(values, `professionalMemberships.${index}.year`)
                            ? new Date(new Date().setFullYear(_.get(values, `professionalMemberships.${index}.year`)))
                            : null
                        }
                        dateFormat="yyyy"
                        showYearPicker
                        autoComplete="off"
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `professionalMemberships.${index}.year`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}></BSForm.Group>
                  </Row>

                  <Row>
                    <Col>
                      <LinkButton
                        label="Remove Professional Membership"
                        onClick={() => remove(index)}
                        icon={faMinusCircle}
                      ></LinkButton>
                    </Col>
                  </Row>
                  <hr
                    style={{
                      marginTop: 32,
                      marginBottom: 32,
                    }}
                  />
                </div>
              ))}
            <Row>
              <Col>
                <LinkButton
                  label="Add Professional Membership"
                  onClick={() =>
                    push({
                      name: '',
                      startDate: '',
                    })
                  }
                ></LinkButton>
              </Col>
            </Row>
          </>
        )}
      </FieldArray>
    </div>
  );
};